import type { CartCustomizationLike } from './CartCustomizationLike'

type ModalCustomizationInput = Record<number, Record<number, number>>

/**
 * Convert flat cart customization array to modal format.
 * Used when opening MenuItemModal in edit mode.
 */
export function cartCustomizationsToModalFormat(
  customizations: CartCustomizationLike[] | null | undefined
): ModalCustomizationInput | undefined {
  if (!customizations || customizations.length === 0) return undefined

  const result: ModalCustomizationInput = {}
  for (const c of customizations) {
    const groupId = c.group_id == null ? NaN : Number(c.group_id)
    const optionId = c.option_id == null ? NaN : Number(c.option_id)
    if (!Number.isFinite(groupId) || !Number.isFinite(optionId)) continue
    result[groupId] ??= {}
    result[groupId][optionId] = (result[groupId][optionId] ?? 0) + 1
  }
  return result
}
